import { initSentry } from "./utils/sentry";

initSentry();
